import React from "react";
import { Link } from "react-router-dom";
import Footer from "../../Layouts/Footer/Footer";
import Header from "../../Layouts/Header/Header";
import Lists from "../Subjects/Lists";

const LandingPage: React.FC = () => {
	return (
		<div className="landing-page">
			<Header />
			<section className="gandal-container mt-6">
				<div className="pt-10">
					<div className="flex justify-between">
						<h2 className="text-slate-900 text-4xl font-semibold leading-tight">
							Bac 2022
						</h2>
						<Link to="/">voir plus...</Link>
					</div>
					<Lists total={8} />
				</div>
				<div className="mt-10">
					<div className="flex justify-between">
						<h2 className="text-slate-900 text-4xl font-semibold leading-tight">
							Tous les sujets
						</h2>
						<Link to="/">voir plus...</Link>
					</div>
					<Lists total={12} />
				</div>
			</section>
			{/* Footer */}
			<Footer />
		</div>
	);
};

export default LandingPage;
